import { render, staticRenderFns } from "./login-view.vue?vue&type=template&id=1129f5b7&"
import script from "./login-view.vue?vue&type=script&lang=ts&"
export * from "./login-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports